var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var _a, _b;
import * as React from 'react';
import { Form, Formik } from 'formik';
import { InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import { PhoneField, TextField } from '@doordash/component-fields';
import ButtonGroup from '@doordash/component-button-group';
import Button from '@doordash/component-button';
import styled from 'styled-components';
import * as yup from 'yup';
import ContactSalesStrings from '../ContactSalesStrings';
import { TEXT_FIELD_MAX_LENGTH } from '../../../constants/values';
var strings = ContactSalesStrings.leadForm;
var InputFieldContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 48%;\n"], ["\n  width: 48%;\n"])));
var LeadFormFields;
(function (LeadFormFields) {
    LeadFormFields["FirstName"] = "firstName";
    LeadFormFields["LastName"] = "lastName";
    LeadFormFields["Email"] = "email";
    LeadFormFields["PhoneNumber"] = "phoneNumber";
    LeadFormFields["CompanyName"] = "companyName";
})(LeadFormFields || (LeadFormFields = {}));
export var initialLeadFormValues = (_a = {},
    _a[LeadFormFields.FirstName] = '',
    _a[LeadFormFields.LastName] = '',
    _a[LeadFormFields.Email] = '',
    _a[LeadFormFields.PhoneNumber] = '',
    _a[LeadFormFields.CompanyName] = '',
    _a);
export var leadFormValidationSchema = yup.object().shape((_b = {},
    _b[LeadFormFields.FirstName] = yup.string().required(strings.errors.required()),
    _b[LeadFormFields.LastName] = yup.string().required(strings.errors.required()),
    _b[LeadFormFields.Email] = yup
        .string()
        .required(strings.errors.required())
        .email(strings.errors.invalidEmail()),
    _b[LeadFormFields.PhoneNumber] = yup
        .string()
        .required(strings.errors.required())
        .min(10, strings.errors.invalidPhone())
        .max(11, strings.errors.invalidPhone()),
    _b[LeadFormFields.CompanyName] = yup
        .string()
        .required(strings.errors.required()),
    _b));
export var LeadForm = function (_a) {
    var isLoading = _a.isLoading, error = _a.error, onSubmit = _a.onSubmit, onBack = _a.onBack;
    return (React.createElement(Formik, { initialValues: initialLeadFormValues, validationSchema: leadFormValidationSchema, validateOnChange: false, validateOnBlur: false, onSubmit: onSubmit }, function (_a) {
        var errors = _a.errors, values = _a.values, handleChange = _a.handleChange, formikSubmit = _a.handleSubmit;
        return (React.createElement(Form, { noValidate: true },
            React.createElement(StackChildren, null,
                React.createElement(InlineChildren, { size: InlineChildren.Sizes.XSmall, justifyContent: InlineChildren.Justification.SpaceBetween },
                    React.createElement(InputFieldContainer, null,
                        React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: strings.firstName.label(), error: errors[LeadFormFields.FirstName], onChange: handleChange(LeadFormFields.FirstName), isRequired: true, value: values[LeadFormFields.FirstName], maxLength: TEXT_FIELD_MAX_LENGTH, autoFocus: true })),
                    React.createElement(InputFieldContainer, null,
                        React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: strings.lastName.label(), error: errors[LeadFormFields.LastName], onChange: handleChange(LeadFormFields.LastName), isRequired: true, value: values[LeadFormFields.LastName], maxLength: TEXT_FIELD_MAX_LENGTH }))),
                React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: strings.email.label(), error: errors[LeadFormFields.Email], onChange: handleChange(LeadFormFields.Email), isRequired: true, value: values[LeadFormFields.Email], maxLength: TEXT_FIELD_MAX_LENGTH }),
                React.createElement(PhoneField, { label: strings.phoneNumber.label(), error: errors[LeadFormFields.PhoneNumber], onChange: handleChange(LeadFormFields.PhoneNumber), isRequired: true, value: values[LeadFormFields.PhoneNumber] }),
                React.createElement(TextField, { isDisabled: false, autoComplete: "off", label: strings.companyName.label(), error: errors[LeadFormFields.CompanyName], onChange: handleChange(LeadFormFields.CompanyName), isRequired: true, value: values[LeadFormFields.CompanyName], maxLength: TEXT_FIELD_MAX_LENGTH }),
                React.createElement(Stack, { size: Stack.Sizes.Large }),
                error && React.createElement(Text, { color: Text.Colors.TextError }, error),
                React.createElement(ButtonGroup, { insetSize: ButtonGroup.Spacing.None, primaryAction: {
                        content: strings.primaryCta.text(),
                        onClick: formikSubmit,
                        buttonProps: {
                            state: isLoading
                                ? Button.States.Loading
                                : Button.States.Default,
                        },
                    }, secondaryAction: onBack
                        ? {
                            content: strings.secondaryCta.text(),
                            onClick: onBack,
                        }
                        : null }))));
    }));
};
var templateObject_1;
